import { useTranslation } from 'react-i18next';
import { Button, Drawer } from '@/components';
import { ProjectTechnology, TechnologyCollection, HydrogenProjectTechnology } from '@/features/projects/types';
import { HydrogenFormNew, HydrogenSubmitFields } from './hydrogen-form-new';

export type HydrogenDrawerProps = {
  readonly formId: string;
  readonly technology: ProjectTechnology;
  readonly isOpen: boolean;
  readonly onSubmit: (collection: TechnologyCollection, item: HydrogenProjectTechnology, description?: string) => void;
  readonly onClose: () => void;
};

export function HydrogenDrawer({ formId, technology, isOpen, onSubmit, onClose }: HydrogenDrawerProps) {
  const { t } = useTranslation(['projects']);
  const footer = (
    <>
      <Button size="lg" color="neutral" onClick={onClose}>
        {t('Cancel')}
      </Button>
      <Button type="submit" form={formId} size="lg" color="primary">
        {t('Save')}
      </Button>
    </>
  );

  return (
    <Drawer title={t('Hydrogen Details & Design')} open={isOpen} onClose={onClose} footer={footer}>
      <HydrogenFormNew
        id={formId}
        item={technology?.item as HydrogenProjectTechnology}
        onSubmit={(data: HydrogenSubmitFields) =>
          onSubmit(
            'projects_hydrogen_technologies',
            { ...technology?.item, ...data, development_status: data.development_status ?? undefined },
            t('Hydrogen Details has been updated')
          )
        }
      />
    </Drawer>
  );
}
